import cc from 'classcat';
import { FornulioLoaderIcon } from '../FornulioLoaderIcon';

type LoaderPosition = 'centerOnScreen' | 'centerOnParent';

export type LoaderSize = 'small' | 'medium' | 'big';

interface ILoader {
    position: LoaderPosition;
    size?: LoaderSize;
}

export const MixerLoader = ({ position, size = 'big' }: ILoader) => {
    return (
        <div
            className={cc([
                'mixer-loader',
                { 'mixer-loader--center-screen': position === 'centerOnScreen' },
                { 'mixer-loader--center-parent': position === 'centerOnParent' },
            ])}
        >
            <div className={`mixer-loader__icon mixer-loader__icon--${size}`}>
                <FornulioLoaderIcon />
            </div>
        </div>
    );
};
